import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import {
  FeedbackTarget,
  RateAi,
} from "@src/features/ai/components/usages/RateAi";
import React from "react";
import { useExecutionPanelContext } from "@src/features/ai/components/WorkflowEditor/execution/panel/ExecutionPanelContext";

interface RateConversationProps {
  feedbackTarget?: FeedbackTarget;
  allowComments?: boolean | undefined;
  metadata?: Record<string, string> | undefined;
}

export const RateConversation = ({
  feedbackTarget,
  allowComments,
  metadata,
}: RateConversationProps) => {
  const { aiChat, feature, workflowId } = useExecutionPanelContext();
  const sessionId = aiChat.sessionId;

  return (
    <div className="flex items-center gap-2">
      <IgTypography variant={"body2"} color={"textSecondary"}>
        Rate this conversation:
      </IgTypography>
      <RateAi
        sessionId={sessionId}
        feature={feature}
        feedbackTarget={feedbackTarget}
        workflowId={workflowId}
        showCommentsDialog={allowComments}
        metadata={metadata}
      />
    </div>
  );
};
